import React, { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { UnRegisteredLayout } from 'app/widgets/main-layout';
import Loader from '../components/Loader';
import digital_routes from './digital';
import loan_routes from './loan';

// Digital Onboarding Pages
const DigitalAccountReviewPage = lazy(() => import('../pages/digital-account/ui/page'));
const DigitalAccountWaitingResponse = lazy(
  () => import('../pages/digital-account/ui/process-status/waiting-operator')
);

// Business Loans;

const OverviewGuest = lazy(() => import('../pages/loan/overview-guest'));

const unregistered_routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <React.Suspense fallback={<Loader />}>
        <Outlet />
      </React.Suspense>
    ),
    children: [
      {
        path: `/:lang/unregistered`,
        element: <UnRegisteredLayout />,
        children: [
          {
            path: 'digital-account',
            element: <Outlet />,
            children: [
              {
                path: 'review',
                element: <DigitalAccountReviewPage />,
              },
              {
                path: 'success',
                element: <DigitalAccountWaitingResponse />,
              },
            ],
          },
          {
            path: 'loan',
            element: <Outlet />,
            children: [
              {
                path: 'overview-guest',
                element: <OverviewGuest />,
              },
            ],
          },
        ],
      },
      ...digital_routes,
      ...loan_routes,
    ],
  },
];

export default unregistered_routes;
